import {
  RESTART_LOGIN,
  VALIDATE_CREDENTIALS_REQUESTED,
  VALIDATE_CREDENTIALS_FAILED,
  AUTH_SUCCESS
} from '../actionCreators/authActions';
import { SET_UI_STATE } from '../actionCreators/uiActions';
import { RESET_STATE } from '../actionCreators/generalActions';

const initialState = {
  uiState: 'request-email',
  apiError: null
};

function loginReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case SET_UI_STATE: {
      return {
        ...state,
        uiState: action.uiState
      };
    }

    case RESTART_LOGIN: {
      const uiState = 'request-email';
      const apiError = undefined;

      return {
        ...state,
        uiState,
        apiError
      };
    }

    case VALIDATE_CREDENTIALS_REQUESTED: {
      const processingMessage = resx('authentication-loginview-processingindicator-loggingin');
      const apiError = undefined;
      const uiState = 'processing';

      return {
        ...state,
        processingMessage,
        apiError,
        uiState
      };
    }

    case VALIDATE_CREDENTIALS_FAILED: {
      const uiState = 'request-password';
      return {
        ...state,
        uiState,
        apiError: action.error
      };
    }

    case AUTH_SUCCESS: {
      const uiState = 'complete';
      return {
        ...state,
        uiState
      };
    }

    case RESET_STATE:
      return { ...initialState };

    default:
      return state;
  }
}

export default loginReducer;
